import { Language } from '../i18n';

export function formatEuros(euros: number, minimumFractionDigits = 0): string {
  return new Intl.NumberFormat(Language.fi, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits,
  }).format(euros);
}

export function formatCentsToEuros(
  cents: number,
  unit?: string,
  decimalSeparator: ',' | '.' = ','
): string {
  const _cents = cents.toString().split('');

  // Should add as many zeros as needed to make the cents length 3
  if (_cents.length < 2) _cents.unshift('0');
  if (_cents.length < 3) _cents.unshift('0');

  _cents.splice(-2, 0, decimalSeparator);
  return _cents.join('') + (unit ? ` ${unit}` : '');
}

export function formatNumberWithSeparators(
  value: number,
  minimumFractionDigits = 0,
  maximumFractionDigits?: number,
  locale = Language.fi
): string {
  return new Intl.NumberFormat(locale, {
    useGrouping: true,
    minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits ?? minimumFractionDigits,
    // @ts-expect-error - Not yet in the types
    roundingMode: 'floor',
  }).format(value);
}

export function formatCentsToEurosWithSeparators(
  cents: number,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  locale = Language.fi
): string {
  return formatNumberWithSeparators(
    cents / 100,
    minimumFractionDigits,
    maximumFractionDigits,
    locale
  );
}
